<div class="input-autocomplete" [class.open]="isOpen" [class.disabled]="searchControl.disabled">
  @if (label) {
    <div class="input-autocomplete-label">
      <label>{{ label }}</label>
    </div>
  }

  <div
    #trigger
    cdkOverlayOrigin
    class="input-autocomplete-item"
    role="combobox"
    tabindex="0"
    [attr.aria-expanded]="isOpen"
    [attr.aria-disabled]="searchControl.disabled"
    (click)="toggleOpen()"
    (keydown.enter)="toggleOpen()"
    (keydown.space)="$event.preventDefault(); toggleOpen()"
  >
    <span class="value" [class.placeholder]="!displayLabel(selectedValue)">
      {{ displayLabel(selectedValue) || placeholder }}
    </span>
    <span class="icon-arrow-down" [class.active]="isOpen">
      <img src="/assets/images/svg/select-arrow-down.svg" alt="arrow-dropdown" />
    </span>
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayWidth]="triggerWidth"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    (overlayOutsideClick)="close()"
    (detach)="close()"
    (attach)="onOverlayAttached()"
  >
    <div class="input-autocomplete-panel">
      <div class="input-autocomplete-panel-search">
        <input
          #searchInput
          type="text"
          class="input-autocomplete-panel-search-input"
          [placeholder]="placeholder"
          [formControl]="searchControl"
          (keydown)="onInputKeydown($event)"
          autocomplete="off"
        />
      </div>

      <div class="input-autocomplete-panel-options">
        @if (filteredOptions$ | async; as options) {
          @if (options.length) {
            @for (option of options; track trackBy($index, option)) {
              <div
                class="input-autocomplete-panel-option"
                [class.selected]="option === selectedValue"
                (click)="selectOption(option)"
              >
                @if (optionTemplate) {
                  <ng-container
                    *ngTemplateOutlet="optionTemplate; context: { $implicit: option }"
                  ></ng-container>
                } @else {
                  {{ displayLabel(option) }}
                }
              </div>
            }
          } @else {
            <div class="input-autocomplete-panel-empty">
              {{ 'components.select.empty-options' | translate }}
            </div>
          }
        }
      </div>
    </div>
  </ng-template>
</div>
